import { motion } from "framer-motion";

const STEPS = [
  { n: "01", title: "Listen", body: "We spend our first hours understanding what you cannot yet say. Site, ritual, budget, silence." },
  { n: "02", title: "Conceptualise", body: "A single defensible idea in a written brief. Mood, materials and moves — not a moodboard." },
  { n: "03", title: "Compose", body: "Plans, elevations, joinery details. Real prototypes of every custom piece before we commit." },
  { n: "04", title: "Curate", body: "Furniture, art, objects, linen, sound — sourced from a network we've trusted for a decade." },
  { n: "05", title: "Execute", body: "We run site every week. One project lead, one WhatsApp thread, one accountable studio." },
  { n: "06", title: "Commission", body: "We stage the first evening. Lights, music, flowers. You walk in and the space is already yours." },
];

export default function Process() {
  return (
    <main className="bg-bone" data-testid="process-page">
      <section className="pt-40 md:pt-56 pb-16">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10">
          <p className="text-[11px] uppercase tracking-[0.3em] text-muteInk mb-6">— Process</p>
          <h1 className="font-serif text-[12vw] md:text-[8vw] leading-[0.9] tracking-tight text-ink">
            End to<br /><span className="italic text-clay">end.</span>
          </h1>
          <p className="mt-10 max-w-xl text-ink/75 leading-relaxed">
            Six chapters, one pencil. From the first conversation to the last touch on site — we stay with the space until it feels lived-in.
          </p>
        </div>
      </section>

      <section className="pb-32 md:pb-40">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 mt-16 md:mt-24 divide-y divide-borderWarm border-t border-borderWarm">
          {STEPS.map((s, i) => (
            <motion.div
              key={s.n}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.8, delay: (i % 3) * 0.05 }}
              className="grid grid-cols-12 gap-6 py-10 md:py-14 hoverable group"
              data-testid={`process-step-${s.n}`}
            >
              <div className="col-span-3 md:col-span-2">
                <span className="chapter-num text-4xl md:text-6xl">{s.n}</span>
              </div>
              <div className="col-span-9 md:col-span-4">
                <h3 className="font-serif text-3xl md:text-5xl leading-tight text-ink group-hover:italic transition-all duration-300">{s.title}</h3>
              </div>
              <div className="col-span-12 md:col-span-6 md:col-start-7 text-ink/75 leading-relaxed">
                {s.body}
              </div>
            </motion.div>
          ))}
        </div>
      </section>
    </main>
  );
}
